import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Text,
  Link as ChakraLink,
  Flex,
  Menu,
  MenuButton,
  HStack,
  Avatar,
  VStack,
  Box,
  useColorModeValue,


  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import {
  FiHome,
  FiTrendingUp,
  FiCompass,
  FiStar,
  FiSettings,
  FiMenu,
  FiBell,
  FiChevronDown,
  FiLogOut,
} from 'react-icons/fi';
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoIcon from "../../assets/svg/Logo";
import BurgerIcon from "../../assets/svg/BurgerIcon";
import Login from "../Login";

import axios from "axios";


import NewSidebar from "./NewSidebar";
export default function NewNavbar() {
  const bgColor = useColorModeValue('white', 'gray.900');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();

  const [userData, setData] = useState('');

  const handleSelected = async () => {
    const res = await axios
      .post("https://glb-api.onrender.com/api/user/logout", {
        token: localStorage.getItem("token"),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => console.log(err));
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/");
  };

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  useEffect(() => {
    axios
      .get('https://glb-api.onrender.com/api/user/details', {withCredentials : true})
      .then((res) => {
        console.log(res.data);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
        // setError('Failed to fetch the details right now.')
      });
  }, []);

  return (
    <>
    <NewSidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
        <NavInner className="container flexSpaceCenter">
          <Link className="pointer flexNullCenter" to="/">
            <LogoIcon />

            <h1 style={{ marginLeft: "15px" }} className="font20 extraBold">
              ReviewMySop
            </h1>
          </Link>
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <Link style={{ padding: "10px 15px" }} to="/">
                Home
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link style={{ padding: "10px 15px" }} to="/RsopHome">
                Services
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link style={{ padding: "10px 15px" }} to="/ourproducts">
                Products
              </Link>
            </li>
            {/* <li className="semiBold font15 pointer">
              <Link style={{ padding: "10px 15px" }} to="/testimonials">
                Testimonials
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link style={{ padding: "10px 15px" }} to="/contact">
                Contact
              </Link>
            </li> */}
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
            {localStorage.getItem('token') ? (
              <>
                <Flex alignItems={'center'}>
                  <Menu>
                    <MenuButton
                      py={2}
                      transition="all 0.3s"
                      _focus={{ boxShadow: 'none' }}
                    >
                      <HStack>
                        <Avatar
                          size={'md'}
                          src={
                            'https://ih1.redbubble.net/image.4909470396.2618/st,small,507x507-pad,600x600,f8f8f8.jpg'
                          }
                        />
                        <VStack
                          display={{ base: 'none', md: 'flex' }}
                          alignItems="flex-start"
                          spacing="1px"
                          ml="2"
                        >
                          <Text fontSize="sm">{userData?.firstName + " " + userData?.lastName}</Text>
                          <Text fontSize="xs" color="gray.600">
                            User
                          </Text>
                        </VStack>
                        <Box display={{ base: 'none', md: 'flex' }}>
                          <FiChevronDown />
                        </Box>
                      </HStack>
                    </MenuButton>
                    <MenuList bg={bgColor} borderColor={borderColor}>
                      <RouterLink to="/trialdash/authentication">
                        <MenuItem>Profile</MenuItem>
                      </RouterLink>

                      <RouterLink to="/trialdash/settings">
                        <MenuItem>My dashboard</MenuItem>
                      </RouterLink>

                      <MenuDivider />

                      <MenuItem onClick={handleSelected}>
                        <HStack>
                          <FiLogOut color="red.100" />
                          <Text color="red" ml="2">
                            Sign out
                          </Text>
                        </HStack>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Flex>
              </>
            ) : (
              <li className="semiBold font15 pointer">
                <a
                  onClick={() => setShowLoginModal(true)}
                  style={{ padding: '10px 30px 10px 0' }}
                >
                  Log in
                </a>
              </li>
            )}
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
      {showLoginModal && (
        <Modal
          isOpen={showLoginModal}
          onClose={() => setShowLoginModal(false)}
        >
          <ModalOverlay />
          <ModalContent>
            {/* <ModalHeader>
              <Heading fontSize="4xl">Sign in to your account</Heading>
              <Text fontSize="lg" color="gray.600">
                to enjoy all of our cool{" "}
                <ChakraLink color="blue.400">features</ChakraLink> ✌️
              </Text>
            </ModalHeader> */}
            <ModalCloseButton />
            <ModalBody>
              <Login />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;

const NavInner = styled.div`
  position: relative;
  height: 100%;
`;

const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;

const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;

const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;
